export default __webpack_public_path__ + "static/media/abstract4.7dd29742.jpeg";